import {
  Tooltip,
  TooltipProps,
  listItemClasses,
  styled,
  tooltipClasses,
  typographyClasses,
  useMediaQuery,
} from "@mui/material"
import { alpha } from "@mui/material/styles"
import React, { useState } from "react"

interface RelendTooltipProps extends TooltipProps {
  children: React.ReactElement
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.mode === "light" ? alpha(theme.palette.common.black, 1) : theme.palette.background.default,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      theme.palette.mode === "light" ? alpha(theme.palette.common.black, 1) : theme.palette.background.default,
    color: "white",
    fontSize: 14,
    [theme.breakpoints.up("sm")]: {
      maxWidth: 420,
    },
    [`.${typographyClasses.body1}`]: {
      color: "white",
      fontSize: 14,
    },
    [`.${listItemClasses.root} .${typographyClasses.body2}`]: {
      color: "white",
      fontSize: 14,
    },
  },
}))

const View = ({ children, ...props }: RelendTooltipProps) => {
  const isMobile = useMediaQuery("(max-width:600px)")
  const [open, setOpen] = useState(false)

  if (isMobile) {
    return (
      <StyledTooltip
        open={open}
        onClose={() => setOpen(false)}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        enterTouchDelay={0}
        leaveTouchDelay={0}
        slotProps={{
          popper: {
            disablePortal: false,
          },
        }}
        {...props}
      >
        {React.cloneElement(children, {
          onClick: (e: React.MouseEvent) => {
            setOpen((prev) => !prev)
            // Preserve existing onClick if any
            if (children.props.onClick) {
              children.props.onClick(e)
            }
          },
        })}
      </StyledTooltip>
    )
  }

  return (
    <StyledTooltip enterTouchDelay={0} leaveTouchDelay={120000} disableTouchListener {...props}>
      {children}
    </StyledTooltip>
  )
}

View.displayName = "RelendTooltip"

export default View
